export default "__VITE_ASSET__f87fb15f__"